const UTILS_CONSTANTS = {
  PROD_URL: 'https://kunden.openbankpay.com/amazon/login',
  BASE_64: 'data:image/png;base64,',
};

const EMPTY_SPACE = ' ';
const EMPTY_STRING = '';
const UNDERSCORE = '_';

export { EMPTY_SPACE, EMPTY_STRING, UNDERSCORE, UTILS_CONSTANTS };
